module.exports = __webpack_public_path__ + "img/1_02.4119eee4.jpg";